import { alpha } from "@mui/material/styles";
import { SystemColors } from "../../../ignite-riddle/fundations/palette/colors";
import { button } from "../../../ignite-riddle/fundations/palette/colorTokens";
const colors = {
    primary: {
        0: "#000000",
        10: "#401E11",
        20: "#691E02",
        30: "#AF4F41",
        40: "#FE5C45",
        50: "#FC8253",
        60: "#FFA364",
        70: "#FFAB72",
        80: "#FFCEAD",
        90: "#FFEBD2",
        95: "#FFF5E8",
        99: "#FEFAF3",
        100: "#FFFFFF"
    },
    secondary: {
        0: "#000000",
        10: "#0A0C12",
        20: "#121721",
        30: "#1A2230",
        40: "#151D4C",
        50: "#394A6B",
        60: "#556990",
        70: "#6B82AD",
        80: "#849AC6",
        90: "#B9CBEE",
        95: "#D5E3FE",
        99: "#F2F6FF",
        100: "#FFFFFF"
    },
    tertiary: {
        0: "#000000",
        10: "#053832",
        20: "#074F46",
        30: "#0C7D6F",
        40: "#12BEA9",
        50: "#31DAC5",
        60: "#41EAD5",
        70: "#64EEDD",
        80: "#8EF9EC",
        90: "#B6FFF6",
        95: "#CCFFF9",
        99: "#EBFFFD",
        100: "#FFFFFF"
    },
    neutral: {
        0: "#000000",
        10: "#1C1B1F",
        20: "#313033",
        30: "#484649",
        40: "#605D62",
        50: "#787579",
        60: "#939094",
        70: "#AEAAAE",
        80: "#C6C6C6",
        90: "#D3D3D3",
        95: "#EAEAEA",
        99: "#F6F6F7",
        100: "#FFFFFF"
    },
    success: {
        10: "#018777",
        40: "#12BEA9",
        90: "#DDFDF9"
    },
    warning: {
        10: "#DF5B00",
        40: "#FFA364",
        90: "#FEEDD8"
    }
};
const primary = {
    light: colors.primary["60"],
    main: colors.primary["40"],
    dark: colors.primary["30"],
    contrastText: colors.neutral["100"],
    container: colors.primary["90"],
    hover: alpha(colors.primary["40"], 0.12),
    focused: alpha(colors.primary["40"], 0.16),
    pressed: alpha(colors.primary["40"], 0.26),
    dragged: alpha(colors.primary["40"], 0.08),
    selected: alpha(colors.primary["40"], 0.24)
};
const success = {
    main: colors.success["40"],
    dark: colors.success["10"],
    contrastText: "#fff",
    container: colors.success["90"]
};
const secondary = {
    light: colors.secondary["60"],
    main: colors.secondary["40"],
    dark: colors.secondary["30"],
    container: colors.secondary["95"],
    hover: alpha(colors.secondary["40"], 0.12),
    focused: alpha(colors.secondary["40"], 0.16),
    pressed: alpha(colors.secondary["40"], 0.26),
    dragged: alpha(colors.secondary["40"], 0.08),
    selected: alpha(colors.secondary["40"], 0.24)
};
const tertiary = {
    light: colors.tertiary["60"],
    main: colors.tertiary["40"],
    dark: colors.tertiary["30"],
    container: colors.tertiary["95"],
    hover: alpha(colors.tertiary["40"], 0.12),
    focused: alpha(colors.tertiary["40"], 0.16),
    pressed: alpha(colors.tertiary["40"], 0.26),
    dragged: alpha(colors.tertiary["40"], 0.08),
    selected: alpha(colors.tertiary["40"], 0.24)
};
const warning = {
    main: colors.warning["40"],
    dark: colors.warning["10"],
    container: colors.warning["90"]
};
const background = {
    default: colors.neutral["99"],
    paper: colors.neutral["100"],
    variant: colors.neutral["90"]
};
// These colors are not used and are just there for making sure MUI complies
const destructive = {
    main: SystemColors.error["500"],
    dark: SystemColors.error["700"]
};
const quarternary = {
    light: colors.secondary["60"],
    main: colors.secondary["40"],
    contrastText: colors.neutral["100"]
};
const ghostGray = {
    main: colors.neutral["100"]
};
const ghostPrimary = {
    main: button["buttonPrimary"].light
};
const linkGray = {
    main: button["buttonPrimary"].light
};
const linkPrimary = {
    main: button["buttonPrimary"].light
};
const none = {
    main: SystemColors.gray["100"],
    contrastText: SystemColors.gray["900"]
};
const gray = {
    main: SystemColors.gray["100"],
    contrastText: SystemColors.gray["900"]
};
const light = {
    mode: "light",
    primary,
    secondary,
    background,
    success,
    tertiary,
    warning,
    // These colors are not used and are just there for making sure MUI complies
    destructive,
    quarternary,
    ghostGray,
    ghostPrimary,
    linkGray,
    linkPrimary,
    neutral: gray,
    gray,
    none
};
export default light;

//# sourceMappingURL=index.js.map